import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

import { PageWrapper, Spin } from "@/components";
import { DynamicFormProvider } from "@/components/DynamicForm/DynamicFormProvider";
import { getFormName, routes } from "@/helpers";
import { useGetAdminFormsQuery, useGetUserTokenQuery } from "@/services";
import { useParams } from "react-router-dom";
import { EditFormContent } from "./EditFormContent";

export const EditForm = () => {
  const { formType } = useParams();
  const intl = useIntl();

  const [formName, setFormName] = useState();
  const [productCategory, setProductCategory] = useState();

  const { data: userToken } = useGetUserTokenQuery();

  const { data: { forms } = {}, isFetching } =
    useGetAdminFormsQuery(productCategory);

  useEffect(() => {
    setProductCategory(userToken?.productCategory);
  }, [userToken?.productCategory]);

  useEffect(() => {
    if (!forms) return;

    setFormName(getFormName(formType));
  }, [formType, forms]);

  if (isFetching || !formName) return <Spin />;

  return (
    <PageWrapper
      pageTitle={intl.formatMessage({ id: "formSelection.pageTitle" })}
      backButtonRoute={routes.admin.forms.list}
      noStyle
    >
      <DynamicFormProvider config={forms[formName]}>
        <EditFormContent
          productCategory={productCategory}
          setProductCategory={setProductCategory}
          formName={formName}
        />
      </DynamicFormProvider>
    </PageWrapper>
  );
};
